export default __webpack_public_path__ + "static/media/defence.274697ec.jpg";